module.exports = __webpack_public_path__ + "img/ps54perxszf9gngq6lctwtifh12oyv84die3ce5350-5449-4258-b640-28ba7d2ced88.85c87433.png";